import { render } from "./LessonAndChat.vue?vue&type=template&id=7088153e&scoped=true"
import script from "./LessonAndChat.vue?vue&type=script&lang=js"
export * from "./LessonAndChat.vue?vue&type=script&lang=js"

import "./my-class-room-responsive.css?vue&type=style&index=0&lang=css&external"
import "./LessonAndChat.vue?vue&type=style&index=1&id=7088153e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7088153e"]])

export default __exports__